import Config from '../../config/config';
var ServerApis = /** @class */ (function () {
    function ServerApis() {
    }
    ServerApis.loginApi = Config.domain + "api/v2/admin/sign_in";
    ServerApis.twoFAToken = Config.domain + "api/v2/admin/two_factor_authentication";
    ServerApis.logoutApi = Config.apiEndpoint + "admin/logout";
    ServerApis.getPromoCodeTypes = Config.apiEndpoint + "admin/coupons/discount_types";
    ServerApis.createPromoCode = Config.apiEndpoint + "admin/coupons";
    ServerApis.getDeliveryMethods = Config.apiEndpoint + "admin/delivery_methods";
    ServerApis.createDeliveryMethod = Config.apiEndpoint + "admin/delivery_methods";
    ServerApis.getDeliveryTypes = Config.apiEndpoint + "admin/delivery_methods/delivery_types";
    ServerApis.getFreeShipping = Config.apiEndpoint + "admin/internal_configurations";
    ServerApis.getPaymentMethods = Config.apiEndpoint + "admin/payment_methods";
    ServerApis.createPaymentMethod = Config.apiEndpoint + "admin/payment_methods";
    ServerApis.createBrand = Config.apiEndpoint + "admin/brands";
    ServerApis.getOptionTypes = Config.apiEndpoint + "admin/option_types";
    ServerApis.getDisplayTypes = Config.apiEndpoint + "admin/option_types/display_types";
    ServerApis.createOptionType = Config.apiEndpoint + "admin/option_types";
    ServerApis.getRegions = Config.apiEndpoint + "admin/regions";
    ServerApis.createRegion = Config.apiEndpoint + "admin/regions";
    ServerApis.getPrices = Config.apiEndpoint + "admin/price_updates";
    ServerApis.createPrice = Config.apiEndpoint + "admin/price_updates";
    ServerApis.getCategories = Config.apiEndpoint + "admin/categories";
    ServerApis.createCategory = Config.apiEndpoint + "admin/categories";
    ServerApis.createSlide = Config.apiEndpoint + "admin/slides";
    ServerApis.createStaticImage = Config.apiEndpoint + "admin/static_images";
    ServerApis.createProduct = Config.apiEndpoint + "admin/products";
    ServerApis.createSearch = Config.apiEndpoint + "admin/exact_searches";
    ServerApis.getProductsStatuses = Config.apiEndpoint + "admin/products/statuses";
    ServerApis.getSpecialOffers = Config.apiEndpoint + "admin/special_offers";
    ServerApis.createSpecialOffer = Config.apiEndpoint + "admin/special_offers";
    ServerApis.getSuggestionOffers = Config.apiEndpoint + "admin/suggestion_offers";
    ServerApis.createSuggestionOffer = Config.apiEndpoint + "admin/suggestion_offers";
    ServerApis.getAdjustmentLevels = Config.apiEndpoint + "admin/adjustment_levels";
    ServerApis.createAdjustmentLevel = Config.apiEndpoint + "admin/adjustment_levels";
    ServerApis.createSample = Config.apiEndpoint + "admin/samples";
    ServerApis.getGifts = Config.apiEndpoint + "admin/gifts";
    ServerApis.createGift = Config.apiEndpoint + "admin/gifts";
    ServerApis.getSamplesStatuses = Config.apiEndpoint + "admin/samples/statuses";
    ServerApis.getGiftsStatuses = Config.apiEndpoint + "admin/gifts/statuses";
    ServerApis.createMainStaticPage = Config.apiEndpoint + "admin/static_pages";
    ServerApis.getMainStaticPages = Config.apiEndpoint + "admin/static_pages";
    ServerApis.getRituals = Config.apiEndpoint + "admin/rituals";
    ServerApis.createRitual = Config.apiEndpoint + "admin/rituals";
    ServerApis.getMainStaticPageTypes = Config.apiEndpoint + "admin/static_pages/page_types";
    ServerApis.createPromoSlide = Config.apiEndpoint + "admin/promo_slides";
    ServerApis.createTemplate = Config.apiEndpoint + "admin/lead_banners";
    ServerApis.createSeoText = Config.apiEndpoint + "admin/home_additions";
    ServerApis.searchBrandsPost = function (searchString) {
        return Config.apiEndpoint + "admin/brands/search?term=" + encodeURIComponent(searchString);
    };
    ServerApis.getSamples = function (params) {
        return Config.apiEndpoint + "admin/samples?page=" + params.page;
    };
    ServerApis.getDisplayOptions = function (brand_id) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_static_pages/displays";
    };
    ServerApis.getVariantQuantity = function (product_id) {
        return Config.apiEndpoint + "admin/products/" + product_id + "/variants/stock_statuses";
    };
    ServerApis.createBrandCategory = function (id) {
        return Config.apiEndpoint + "admin/brands/" + id + "/brand_categories";
    };
    ServerApis.getBrandCategories = function (id) {
        return Config.apiEndpoint + "admin/brands/" + id + "/brand_categories";
    };
    ServerApis.getBrandCategory = function (brand_id, id) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_categories/" + id;
    };
    ServerApis.updateBrandCategory = function (brand_id, id) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_categories/" + id;
    };
    ServerApis.getSample = function (id) { return Config.apiEndpoint + "admin/samples/" + id; };
    ServerApis.getGift = function (id) { return Config.apiEndpoint + "admin/gifts/" + id; };
    ServerApis.updateSample = function (id) { return Config.apiEndpoint + "admin/samples/" + id; };
    ServerApis.updateGift = function (id) { return Config.apiEndpoint + "admin/gifts/" + id; };
    ServerApis.getRitual = function (id) { return Config.apiEndpoint + "admin/rituals/" + id; };
    ServerApis.updateRitual = function (id) { return Config.apiEndpoint + "admin/rituals/" + id; };
    ServerApis.updateCategoryProduct = function (catId, prodId) {
        return Config.apiEndpoint + "admin/categories/" + catId + "/products/" + prodId;
    };
    ServerApis.deleteRitual = function (id) { return Config.apiEndpoint + "admin/rituals/" + id; };
    ServerApis.deleteSample = function (id) { return Config.apiEndpoint + "admin/samples/" + id; };
    ServerApis.deleteGift = function (id) { return Config.apiEndpoint + "admin/gifts/" + id; };
    ServerApis.deleteBrandCategory = function (brand_id, id) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_categories/" + id;
    };
    ServerApis.getMainStaticPage = function (id) { return Config.apiEndpoint + "admin/static_pages/" + id; };
    ServerApis.updateMainStaticPage = function (id) { return Config.apiEndpoint + "admin/static_pages/" + id; };
    ServerApis.deleteMainStaticPage = function (id) { return Config.apiEndpoint + "admin/static_pages/" + id; };
    ServerApis.getDeliveryMethod = function (id) { return Config.apiEndpoint + "admin/delivery_methods/" + id; };
    ServerApis.getPromoCode = function (id) { return Config.apiEndpoint + "admin/coupons/" + id; };
    ServerApis.updateDeliveryMethod = function (id) { return Config.apiEndpoint + "admin/delivery_methods/" + id; };
    ServerApis.updateFreeShipping = function () { return Config.apiEndpoint + "admin/internal_configurations"; };
    ServerApis.updatePromoCode = function (id) { return Config.apiEndpoint + "admin/coupons/" + id; };
    ServerApis.getPaymentMethod = function (id) { return Config.apiEndpoint + "admin/payment_methods/" + id; };
    ServerApis.updatePaymentMethod = function (id) { return Config.apiEndpoint + "admin/payment_methods/" + id; };
    ServerApis.getBrands = function (num) { return Config.apiEndpoint + "admin/brands?page=" + num; };
    ServerApis.searchBrands = function (searchString) {
        return Config.apiEndpoint + "admin/brands?term=" + searchString;
    };
    ServerApis.searchBarcode = function (searchString) {
        return Config.apiEndpoint + "admin/exact_searches/search?term=" + searchString;
    };
    ServerApis.searchOneResult = function (id) { return Config.apiEndpoint + "admin/exact_searches/" + id; };
    ServerApis.searchGifts = function (searchString) {
        return Config.apiEndpoint + "admin/gifts?term=" + searchString;
    };
    ServerApis.searchProducts = function (searchString) {
        return Config.apiEndpoint + "admin/products/search?term=" + searchString;
    };
    ServerApis.searchPromoCodes = function (searchString) {
        return Config.apiEndpoint + "admin/coupons/search?term=" + searchString;
    };
    ServerApis.searchProductsCategory = function (searchString, category_id) {
        return Config.apiEndpoint + "admin/categories/" + category_id + "/product_search?term=" + searchString;
    };
    ServerApis.getBrand = function (id) { return Config.apiEndpoint + "admin/brands/" + id; };
    ServerApis.updateBrand = function (id) { return Config.apiEndpoint + "admin/brands/" + id; };
    ServerApis.getOptionType = function (id) { return Config.apiEndpoint + "admin/option_types/" + id; };
    ServerApis.updateOptionType = function (id) { return Config.apiEndpoint + "admin/option_types/" + id; };
    ServerApis.getOptionValues = function (optionTypeId, num) {
        return Config.apiEndpoint + "admin/option_types/" + optionTypeId + "/option_values?page=" + num;
    };
    ServerApis.createOptionValue = function (optionTypeId) {
        return Config.apiEndpoint + "admin/option_types/" + optionTypeId + "/option_values";
    };
    ServerApis.getOptionValue = function (optionTypeId, optionValueId) {
        return Config.apiEndpoint + "admin/option_types/" + optionTypeId + "/option_values/" + optionValueId;
    };
    ServerApis.searchOptionValues = function (optionTypeId, term) {
        return Config.apiEndpoint + "admin/option_values/search?term=" + term + "&option_type_id=" + optionTypeId;
    };
    ServerApis.updateOptionValue = function (optionTypeId, optionValueId) {
        return Config.apiEndpoint + "admin/option_types/" + optionTypeId + "/option_values/" + optionValueId;
    };
    ServerApis.getRegion = function (id) { return Config.apiEndpoint + "admin/regions/" + id; };
    ServerApis.updateRegion = function (id) { return Config.apiEndpoint + "admin/regions/" + id; };
    ServerApis.deleteRegion = function (id) { return Config.apiEndpoint + "admin/regions/" + id; };
    ServerApis.getPrice = function (id) { return Config.apiEndpoint + "admin/price_updates/" + id; };
    ServerApis.updatePrice = function (id) { return Config.apiEndpoint + "admin/price_updates/" + id; };
    ServerApis.deletePrice = function (id) { return Config.apiEndpoint + "admin/price_updates/" + id; };
    ServerApis.deleteUser = function (id) { return Config.apiEndpoint + "admin/users/" + id; };
    ServerApis.getUsers = function (params) {
        return Config.apiEndpoint + "admin/users?page=" + params.pageNumber + (params.filter !== '' ? "&email=" + params.filter : '');
    };
    ServerApis.getOrders = function (params) {
        return Config.apiEndpoint + "admin/orders?page=" + params.page;
    };
    ServerApis.getProblemOrders = function (params) {
        return Config.apiEndpoint + "admin/orders/problems?page=" + params.page;
    };
    ServerApis.getOrder = function (num) { return Config.apiEndpoint + "admin/orders/" + num; };
    ServerApis.refreshOrderStatus = function (num) { return Config.apiEndpoint + "admin/orders/" + num + "/erp_states"; };
    ServerApis.resenderErpStatus = function (num) { return Config.apiEndpoint + "admin/orders/" + num + "/resenders"; };
    ServerApis.refreshButtonStatus = function () { return Config.apiEndpoint + "admin/price_updates"; };
    ServerApis.resenderRefreshButton = function () { return Config.apiEndpoint + "admin/price_updates"; };
    ServerApis.uploadPromocodeFile = function () { return Config.apiEndpoint + "admin/coupon_imports"; };
    ServerApis.getVolumePromotions = function (params) {
        return Config.apiEndpoint + "admin/volume_promotions?page=" + params.page;
    };
    ServerApis.createVolumePromotion = function () { return Config.apiEndpoint + "admin/volume_promotions"; };
    ServerApis.getVolumePromotion = function (id) { return Config.apiEndpoint + "admin/volume_promotions/" + id; };
    ServerApis.getLevelsForVolumePromotion = function (id) {
        return Config.apiEndpoint + "admin/volume_promotions/" + id + "/levels";
    };
    ServerApis.getLevelForVolumePromotion = function (id, levelId) {
        return Config.apiEndpoint + "admin/volume_promotions/" + id + "/levels/" + levelId;
    };
    ServerApis.volumePromotionImport = function () { return Config.apiEndpoint + "admin/volume_promotion_imports"; };
    ServerApis.searchOrders = function (params) {
        var formatQueryString = ServerApis.formatSearchOrderParams(params);
        var queryString = formatQueryString ? "?" + formatQueryString : '';
        var searchTerm = params.filter; // This could be any value you want to include in the URL
        var encodedSearchTerm = encodeURIComponent(searchTerm);
        return Config.apiEndpoint + "admin/orders/search?term=" + encodedSearchTerm;
    };
    ServerApis.searchProblemOrders = function (params) {
        var formatQueryString = ServerApis.formatSearchOrderParams(params);
        var queryString = formatQueryString ? "?" + formatQueryString : '';
        return Config.apiEndpoint + "admin/orders/problems/search" + queryString;
    };
    ServerApis.assignOperatorToOrder = function (id) {
        return Config.apiEndpoint + "admin/orders/" + id + "/assignings";
    };
    ServerApis.getCategory = function (id) { return Config.apiEndpoint + "admin/categories/" + id; };
    ServerApis.searchCategories = function (searchString) {
        return Config.apiEndpoint + "admin/categories/search?term=" + searchString;
    };
    ServerApis.updateCategory = function (id) { return Config.apiEndpoint + "admin/categories/" + id; };
    ServerApis.deleteCategory = function (id) { return Config.apiEndpoint + "admin/categories/" + id; };
    ServerApis.hideCategory = function (id) { return Config.apiEndpoint + "admin/categories/" + id + "/admin_hide"; };
    ServerApis.searchCategory = function (text) {
        return Config.apiEndpoint + "admin/categories/search?term=" + text;
    };
    ServerApis.searchBrandCategory = function (text) {
        return Config.apiEndpoint + "admin/brands/brand_categories/search?term=" + text;
    };
    ServerApis.getCategorySlides = function (categoryId) {
        return Config.apiEndpoint + "admin/categories/" + categoryId + "/slides";
    };
    ServerApis.getCategorySlide = function (categoryId, slideId) {
        return Config.apiEndpoint + "admin/categories/" + categoryId + "/slides/" + slideId;
    };
    ServerApis.deleteCategorySlide = function (categoryId, slideId) {
        return Config.apiEndpoint + "admin/categories/" + categoryId + "/slides/" + slideId;
    };
    ServerApis.updateCategorySlide = function (categoryId, slideId) {
        return Config.apiEndpoint + "admin/categories/" + categoryId + "/slides/" + slideId;
    };
    ServerApis.createCategorySlide = function (categoryId) {
        return Config.apiEndpoint + "admin/categories/" + categoryId + "/slides";
    };
    // Static Page Slides - list/create
    ServerApis.getStaticPageSlides = function (brand_id, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_static_pages/" + staticPageId + "/slides";
    };
    // Static page Slide - single/update/delete
    ServerApis.getStaticPageSlide = function (brand_id, staticPageId, slideId) {
        return Config.apiEndpoint + "admin/brands/" + brand_id + "/brand_static_pages/" + staticPageId + "/slides/" + slideId;
    };
    ServerApis.getSlides = function () { return Config.apiEndpoint + "admin/slides"; };
    ServerApis.getSlide = function (id) { return Config.apiEndpoint + "admin/slides/" + id; };
    ServerApis.updateSlide = function (id) { return Config.apiEndpoint + "admin/slides/" + id; };
    ServerApis.deleteSlide = function (id) { return Config.apiEndpoint + "admin/slides/" + id; };
    ServerApis.getPromoSlides = function () { return Config.apiEndpoint + "admin/promo_slides"; };
    ServerApis.getPromoSlide = function (id) { return Config.apiEndpoint + "admin/promo_slides/" + id; };
    ServerApis.updatePromoSlide = function (id) { return Config.apiEndpoint + "admin/promo_slides/" + id; };
    ServerApis.deletePromoSlide = function (id) { return Config.apiEndpoint + "admin/promo_slides/" + id; };
    ServerApis.getStaticImages = function (params) {
        return Config.apiEndpoint + "admin/static_images" + (params.filter ? "/search?term=" + params.filter + "&" : '?') + "page=" + params.pageNumber;
    };
    ServerApis.deleteStaticImage = function (id) { return Config.apiEndpoint + "admin/static_images/" + id; };
    ServerApis.searchStaticImages = function (searchString) {
        return Config.apiEndpoint + "admin/static_images/search?term=" + searchString;
    };
    // search
    ServerApis.getSearches = function () { return Config.apiEndpoint + "admin/exact_searches"; };
    ServerApis.getSearchStatuses = function () { return Config.apiEndpoint + "admin/exact_searches/statuses"; };
    // public static postSearches = (data: any): any => `${Config.apiEndpoint}admin/exact_searches`;
    // Homepage Template
    ServerApis.getTemplates = function () { return Config.apiEndpoint + "admin/lead_banners"; };
    ServerApis.getTypeTemplate = function () { return Config.apiEndpoint + "admin/lead_banners/templates"; };
    ServerApis.templateOneResult = function (id) { return Config.apiEndpoint + "admin/lead_banners/" + id; };
    ServerApis.updateTemplate = function (id) { return Config.apiEndpoint + "admin/lead_banners/" + id; };
    ServerApis.deleteTemplate = function (id) { return Config.apiEndpoint + "admin/lead_banners/" + id; };
    // seo text in home page
    ServerApis.getSeoTextHome = function () { return Config.apiEndpoint + "admin/home_additions"; };
    ServerApis.getPromoCodes = function (num) { return Config.apiEndpoint + "admin/coupons?page=" + num; };
    ServerApis.getProducts = function (num) { return Config.apiEndpoint + "admin/products?page=" + num; };
    ServerApis.getCategoryProducts = function (id, page) {
        if (page === void 0) { page = 1; }
        return Config.apiEndpoint + "admin/categories/" + id + "/products?page=" + page;
    };
    ServerApis.getProduct = function (id) { return Config.apiEndpoint + "admin/products/" + id; };
    ServerApis.updateProduct = function (id) { return Config.apiEndpoint + "admin/products/" + id; };
    ServerApis.updateSearch = function (id) { return Config.apiEndpoint + "admin/exact_searches/" + id; };
    // public static updateProduct = (id: string): string => `${Config.apiEndpoint}admin/products/${id}`;
    ServerApis.getReviews = function (productId, num) {
        return Config.apiEndpoint + "admin/products/" + productId + "/reviews?page=" + num;
    };
    ServerApis.getUnapprovedReviews = function (num) { return Config.apiEndpoint + "admin/reviews?page=" + num; };
    ServerApis.getReview = function (reviewsId) { return Config.apiEndpoint + "admin/reviews/" + reviewsId; };
    ServerApis.deleteReview = function (reviewsId) { return Config.apiEndpoint + "admin/reviews/" + reviewsId; };
    ServerApis.updateReview = function (reviewsId) { return Config.apiEndpoint + "admin/reviews/" + reviewsId; };
    ServerApis.getRelatedCollections = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/related_collections";
    };
    ServerApis.createRelatedCollection = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/related_collections";
    };
    ServerApis.getRelatedCollection = function (productId, id) {
        return Config.apiEndpoint + "admin/products/" + productId + "/related_collections/" + id;
    };
    ServerApis.deleteRelatedCollection = function (productId, id) {
        return Config.apiEndpoint + "admin/products/" + productId + "/related_collections/" + id;
    };
    ServerApis.getBrandSlides = function (brandId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_slides";
    };
    ServerApis.getBrandSlide = function (brandId, slideId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_slides/" + slideId;
    };
    ServerApis.deleteBrandSlide = function (brandId, slideId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_slides/" + slideId;
    };
    ServerApis.updateBrandSlide = function (brandId, slideId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_slides/" + slideId;
    };
    ServerApis.createBrandSlide = function (brandId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_slides";
    };
    ServerApis.getProductLines = function (brandId, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages/" + staticPageId + "/brand_product_lines";
    };
    ServerApis.deleteProductLine = function (productLineId) {
        return Config.apiEndpoint + "admin/brand_product_lines/" + productLineId;
    };
    ServerApis.getProductLine = function (productLineId) {
        return Config.apiEndpoint + "admin/brand_product_lines/" + productLineId;
    };
    ServerApis.updateProductLine = function (productLineId) {
        return Config.apiEndpoint + "admin/brand_product_lines/" + productLineId;
    };
    ServerApis.createProductLine = function (brandId, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages/" + staticPageId + "/brand_product_lines";
    };
    // Static page product lines
    ServerApis.getStaticProductLines = function (staticPageId) {
        return Config.apiEndpoint + "admin/static_pages/" + staticPageId + "/product_lines";
    };
    ServerApis.deleteStaticProductLine = function (staticPageId, productLineId) {
        return Config.apiEndpoint + "admin/static_pages/" + staticPageId + "/product_lines/" + productLineId;
    };
    ServerApis.getStaticProductLine = function (staticPageId, productLineId) {
        return Config.apiEndpoint + "admin/static_pages/" + staticPageId + "/product_lines/" + productLineId;
    };
    ServerApis.updateStaticProductLine = function (staticPageId, productLineId) {
        return Config.apiEndpoint + "admin/static_pages/" + staticPageId + "/product_lines/" + productLineId;
    };
    ServerApis.createStaticProductLine = function (staticPageId) {
        return Config.apiEndpoint + "admin/static_pages/" + staticPageId + "/product_lines";
    };
    ServerApis.getStaticPages = function (brandId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages";
    };
    ServerApis.getStaticPage = function (brandId, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages/" + staticPageId;
    };
    ServerApis.deleteStaticPage = function (brandId, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages/" + staticPageId;
    };
    ServerApis.updateStaticPage = function (brandId, staticPageId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages/" + staticPageId;
    };
    ServerApis.createStaticPage = function (brandId) {
        return Config.apiEndpoint + "admin/brands/" + brandId + "/brand_static_pages";
    };
    ServerApis.getVariants = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants";
    };
    ServerApis.createVariant = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants";
    };
    ServerApis.getVariant = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId;
    };
    ServerApis.updateVariant = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId;
    };
    ServerApis.getVariantStatuses = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/statuses";
    };
    ServerApis.createColorImage = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/color_images";
    };
    ServerApis.getColorImage = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/color_images";
    };
    ServerApis.updateColorImage = function (productId, variantId, colorImageId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/color_images/" + colorImageId;
    };
    ServerApis.deleteColorImage = function (productId, variantId, colorImageId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/color_images/" + colorImageId;
    };
    ServerApis.createAdditionalImage = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/additional_images";
    };
    ServerApis.getAdditionalImage = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/additional_images";
    };
    ServerApis.updateAdditionalImage = function (productId, id) {
        return Config.apiEndpoint + "admin/products/" + productId + "/additional_images/" + id;
    };
    ServerApis.deleteAdditionalImage = function (productId, id) {
        return Config.apiEndpoint + "admin/products/" + productId + "/additional_images/" + id;
    };
    ServerApis.getVariantImages = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/variant_images";
    };
    ServerApis.createVariantImage = function (productId, variantId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/variant_images";
    };
    ServerApis.getVariantImage = function (productId, variantId, variantImageId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/variant_images/" + variantImageId;
    };
    ServerApis.updateVariantImage = function (productId, variantId, variantImageId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/variant_images/" + variantImageId;
    };
    ServerApis.deleteVariantImage = function (productId, variantId, variantImageId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/variants/" + variantId + "/variant_images/" + variantImageId;
    };
    ServerApis.getFilterOptions = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options";
    };
    ServerApis.createFilterOption = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options";
    };
    ServerApis.getFilterOption = function (productId, filterOptionId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options/" + filterOptionId;
    };
    ServerApis.deleteFilterOption = function (productId, filterOptionId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options/" + filterOptionId;
    };
    ServerApis.updateFilterOption = function (productId, filterOptionId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options/" + filterOptionId;
    };
    ServerApis.getFilterTypes = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/filter_options/filter_types";
    };
    ServerApis.getSpecialOffer = function (id) { return Config.apiEndpoint + "admin/special_offers/" + id; };
    ServerApis.updateSpecialOffer = function (id) { return Config.apiEndpoint + "admin/special_offers/" + id; };
    ServerApis.deleteSpecialOffer = function (id) { return Config.apiEndpoint + "admin/special_offers/" + id; };
    ServerApis.getSuggestionOffer = function (id) { return Config.apiEndpoint + "admin/suggestion_offers/" + id; };
    ServerApis.updateSuggestionOffer = function (id) { return Config.apiEndpoint + "admin/suggestion_offers/" + id; };
    ServerApis.deleteSuggestionOffer = function (id) { return Config.apiEndpoint + "admin/suggestion_offers/" + id; };
    ServerApis.deleteSearch = function (id) { return Config.apiEndpoint + "admin/exact_searches/" + id; };
    ServerApis.deletePromoCode = function (id) { return Config.apiEndpoint + "admin/coupons/" + id; };
    ServerApis.deleteAdjustmentLevel = function (id) { return Config.apiEndpoint + "admin/adjustment_levels/" + id; };
    ServerApis.getProductLabels = function () { return Config.apiEndpoint + "admin/products/labels"; };
    ServerApis.generateBol = function (order_number) {
        return Config.apiEndpoint + "admin/orders/" + order_number + "/bols";
    };
    ServerApis.getAromaticNotes = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/aromatic_notes";
    };
    ServerApis.getAromaticNote = function (productId, aromaticNoteId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/aromatic_notes/" + aromaticNoteId;
    };
    ServerApis.createAromaticNote = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/aromatic_notes";
    };
    ServerApis.deleteAromaticNote = function (productId, aromaticNoteId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/aromatic_notes/" + aromaticNoteId;
    };
    ServerApis.getAromaticNoteTypes = function (productId) {
        return Config.apiEndpoint + "admin/products/" + productId + "/aromatic_notes/note_types";
    };
    ServerApis.formatSearchOrderParams = function (params) {
        var queryFilters = [];
        if (params.page && params.page > 1) {
            queryFilters.push("page=" + params.page);
        }
        if (params.filter) {
            queryFilters.push("term=" + params.filter);
        }
        return queryFilters.length ? queryFilters.join('&') : '';
    };
    return ServerApis;
}());
export default ServerApis;



//////////////////
// WEBPACK FOOTER
// ./src/classes/http/ServerApis.ts
// module id = 231
// module chunks = 0